<template>
  <div class="saldos-fluxo-de-caixa">
    <span>{{ title }}</span> 
    <span v-if="showDetails">
      <b-button  :style="`${textColor} ${btnStyleSaldos}`" v-b-modal.saldoInicial>
        <i class="el-icon-search"/>
        {{ this.toMoney(amount) }}
      </b-button>
    </span>
    <span v-else :style="textColor">
      {{ this.toMoney(amount) }}
    </span>
    <b-modal
        v-if="showDetails"
				id="saldoInicial"
				size="lg"
				no-close-on-esc
				no-close-on-backdrop
				:title="`Detalhes de fluxo de caixa - Saldo Inicial`"
				tabindex="-1"
				>
        <div class="table-container overflow-auto">

          <table class="table-saldo-inicial b-table table table-bordered table-striped bv-docs-table">
            <thead class="thead-default table-secondary table-header-saldos">
                <tr>
                    <th  class="font-weight-bold " v-for="label in tableLabels" v-bind:key="label">{{ label }}</th>
                </tr>
            </thead>
            <tbody v-if="haContas">
                <tr  v-for="item in saldosTable" v-bind:key="item.id">
                    <td  class="info-saldos-detalhes">
                        <ul>
                          <li><b>Nome: </b> {{ item.nome || ''}}</li>
                          <li><b>Empresa: </b> {{ item.dadosDaConta.empresaNome || ''}}</li>
                          <li><b>CNPJ: </b> {{ item.dadosDaConta.empresaCNPJ || ''}}</li>
                          <li><b>Banco: </b>{{ item.dadosDaConta.banco || ''}}</li>
                          <li><b>Agencia: </b>{{ item.dadosDaConta.agencia || ''}}</li>
                          <li><b>Conta: </b> {{ item.dadosDaConta.contaComDigito || ''}}</li>
                          <li><b>Tipo: </b> {{ item.dadosDaConta.tipo || ''}}</li>
                        </ul>
                    </td>
                    <td class="text-right text-success text-nowrap">{{ item.valor }}</td>
                    <td class="info-saldos-obs">
                        <p>{{ item.observacao }}</p>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4">
                  <p class="text-secondary">
                    Não localizamos nenhuma conta autorizada para exibição de saldo. Para liberar o acesso, o franqueado 
                    deverá seguir os procedimentos descritos no seguinte artigo:  
                    <a :href="sanitizedHref(linkArtigo)" target="_blank" rel="noopener">Click aqui</a> 
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="alert alert-info">
            <p class="mb-0">
              <b>Sentiu falta de alguma conta?</b> Peça ao franqueado para seguir os 
              procedimento descritos no seguinte artigo: 
              <a :href="sanitizedHref(linkArtigo)" target="_blank" rel="noopener">Click aqui</a> 
             </p>
          </div>
        </div>

        <template #modal-footer="{ hide }">
					<div class="float-right">
						<el-button size="small" @click="hide()">Fechar</el-button>
					</div>
				</template>
  </b-modal>
  </div>
</template>
<script>

export default {
  name: 'SaldosFluxoDeCaixa',
  data () {
    return {
      tableLabels: ['Dados da conta', 'Valor', 'Observação'],
      linkArtigo: 'https://f360.zendesk.com/hc/pt-br/articles/12998722188183'
    }
  },
  methods: {
  },
  computed:{
    textColor(){
      const styles = {
        true: 'color:var(--green);',
        [this.amount  < 0]: 'color:var(--danger); ',
        [this.amount  === 0]:  'color:var(--primary); '
     };
      
      return styles.true;
    },
    saldosTable(){
      const saldosTableInfos = this.contas.map(col => {
        col.valor = this.toMoney(col.valor);
      
        return col;
      });
      return saldosTableInfos;
    },
    btnStyleSaldos(){
      return 'padding:0; background: none; border:none; box-shadow:none;';
    },
    haContas(){
      return this.contas.length;
    }
  },
  props:{
    title:{ required: true, type: String },
    amount:{ required: true, type: Number  },
    showDetails:{ type: Boolean, default: false },
    contas: { type: Array },
  }
};
</script>

<style lang="scss">

.saldos-fluxo-de-caixa{
  display: flex;
  justify-content: space-between;
  align-items: center;
  span{
    border: 0.2px solid #9292923f;
    width: 100%;
    min-height: 45px;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    background:var(--light)
  }
}
.table-saldo-inicial{
  font-size: 13px;
  .info-saldos-detalhes{
    min-width: 250px;
    line-height: 150%;
    ul{
      list-style-type: none;
    }
  }
}
.table-container{
  height: 400px;
  .alert-info{
    font-size: 13px;
  }
  .table-header-saldos{
    text-align: center;
  }
}

</style>
